import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { CHANGE_COUNTRY_FILTER } from 'actions/travelSecurity/countries/actions';
import Raven from 'raven-js';
import { getAlertsByCountry } from 'api/alerts';
import { getAuth } from 'actions/auth/login';
import { getCountryFilterCode } from 'actions/travelSecurity/countries/selectors';
import { getLocale } from 'actions/language/selectors';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';

export const FETCH_ALERT_DATA = 'ALERT/FETCH_ALERT_DATA';
export const SUCCESS_FETCHING_ALERT_DATA = 'ALERT/SUCCESS_FETCHING_ALERT_DATA';
export const ERROR_FETCHING_ALERT_DATA = 'ALERT/ERROR_FETCHING_ALERT_DATA';

/*** Action Creators ***/
export const fetchAlertData = () => ({
  type: FETCH_ALERT_DATA
});

export const successFetchingAlertData = (data) => ({
  type: SUCCESS_FETCHING_ALERT_DATA,
  alerts: data
});

export const errorFetchingAlertData = () => ({
  type: ERROR_FETCHING_ALERT_DATA
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  alerts: []
};

export default function AlertReducer(
  state = DEFAULT_STATE,
  { alerts, error, type } = {}
) {
  switch (type) {
    case ERROR_FETCHING_ALERT_DATA:
      Raven.captureException(error, { state });
      return {
        ...state,
        error
      };
    case SUCCESS_FETCHING_ALERT_DATA:
      return {
        ...state,
        alerts
      };
    case FETCH_ALERT_DATA:
    default:
      return state;
  }
}

/*** Sagas ***/
// Worker
export function* initializeAsyncAlertWorker() {
  try {
    const auth = yield select(getAuth);
    const locale = yield select(getLocale);
    const selectedCountry = yield select(getCountryFilterCode);
    if (selectedCountry) {
      const data = yield call(
        getAlertsByCountry,
        locale,
        auth,
        selectedCountry
      );
      yield put(successFetchingAlertData(data.alerts));
    }
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* alertSaga() {
  yield all([
    takeEvery(FETCH_ALERT_DATA, initializeAsyncAlertWorker),
    takeEvery(CHANGE_COUNTRY_FILTER, initializeAsyncAlertWorker)
  ]);
}



// WEBPACK FOOTER //
// ./src/actions/travelSecurity/alerts/actions.js